
@if (vendorGroupList?.length) {
  @for (item of vendorGroupList; track item; let j = $index) {
    <div class="mt-1 po-vendor-group">
      <!-- Expansion Panel -->
      <mat-expansion-panel [disabled]="true" [expanded]="item?.isExpand">
        <mat-expansion-panel-header
          class="expansion-header">
          <mat-panel-title>
            <!-- Button to toggle panel -->
            <button mat-icon-button (click)="togglePanel(item)" class="mat-expension-btn"
              [attr.aria-label]="item?.isExpand ? 'Close panel' : 'Open panel'">
              <mat-icon>{{ item?.isExpand ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            <div class="pl-3 text-black po-vendor-name">
              @if (item?.is_discount) {
                <img src="../../../../assets/img/general_icons/dicount-tag-icon.svg" alt=""
                  >
              }
              {{item?.name}}
            </div>
            @if (isSplitedItem) {
              <div class="pl-3 text-danger">
                {{item?.uniqueCode}}
              </div>
            }
          </mat-panel-title>
          <mat-panel-description>
            <div class="po-vendor-row__controls">
              @if (purchaseOrderObject.group_material_flag && ((item.materialList.length > 1 && item?.isGroupMaterial) || checkSplitMaterialChecked(item))) {
                <div>
                  <!-- Check if vendor exists in separatePOJobList -->
                  @if (isSplitedItem ? getUniqueCodesForVandor(item)?.length : uniqueCodes?.length) {
                    <mat-select placeholder="Select PO" (selectionChange)="onVendorActionSelect($event, item)">
                      @if (!isSplitedItem) {
                        <mat-option value="new">Split PO</mat-option>
                      }
                      @if (isSplitedItem) {
                        <mat-option value="main">Main PO</mat-option>
                      }
                      @for (code of isSplitedItem ? getUniqueCodesForVandor(item)?.codes : uniqueCodes; track code) {
                        <mat-option [value]="code">
                          {{ code }}
                        </mat-option>
                      }
                    </mat-select>
                  } @else {
                    <button mat-raised-button color="" (click)="splitPO.next(isSplitedItem ? {target: 'main'} : {target: 'new'}); item.isGroupMaterial = false"
                      [disabled]="isSplitedItem ? false : materialSplitGroupList.length === 0">
                      {{isSplitedItem? 'Main PO' : 'Split PO'}}
                    </button>
                  }
                  <!-- Show only Split PO button if vendor not in separatePOJobList -->
                </div>
              }
              <!-- Quote Number -->
              <label for="quote_number" class="col-form-label text-black po-vendor-label">
              Quote Number</label>
              <input
                [ngClass]="{'border-red': (quote_number.touched || purchaseForm.submitted) && quote_number.errors?.['required']}"
                type="text" class="form-control po-vendor-input" [(ngModel)]="item.quote_number"
                placeholder="Type here" id="quote_number{{ j }}"
                name="quote_number{{ j }}" required #quote_number="ngModel"
                [ngModelOptions]="{standalone: true}">
              <!-- Shipment with Visual Indicators -->
              <div class="d-flex align-items-center">
                <!-- The tooltips name what the click does, not the state the
                     icon already shows. They were the wrong way round: the one
                     reading "Add Shipping Charges" was the button that turned
                     charges off. -->
                @if (!item.is_free_shipping) {
                  <mat-icon matTooltip="Free Shipping"
                    class="po-vendor-shipment-icon"
                  (click)="shippmentToggleFn(item)">local_shipping</mat-icon>
                }
                @if (item.is_free_shipping) {
                  <mat-icon matTooltip="Add Shipping Charges"
                    class="po-vendor-shipment-icon po-vendor-shipment-icon--cancelled"
                  (click)="shippmentToggleFn(item)">no_transfer</mat-icon>
                }
                <label for="shipping_cost"
                  [ngClass]="{'text-danger': (isSplitedItem && !item.is_free_shipping && (!item.fee_ship || item.fee_ship === 0)), 'text-black': (!isSplitedItem || item.is_free_shipping || (item.fee_ship && item.fee_ship > 0))}"
                  class="col-form-label po-vendor-label">
                  Shipment
                  @if (isSplitedItem && !item.is_free_shipping && (!item.fee_ship || item.fee_ship === 0)) {
                    <span
                      class="text-danger ml-1"
                      matTooltip="Shipping charge was reset after split - please add shipping cost">
                      *
                    </span>
                  }
                </label>
              </div>
              <div class="position-relative">
                <span class="dollar-sign">$</span>
                <input
                                                [ngClass]="{'border-red': (fee_ship.touched || purchaseForm.submitted) && fee_ship.errors?.['required'],
                                                           'border-warning': (isSplitedItem && !item.is_free_shipping && (!item.fee_ship || item.fee_ship === 0)),
                                                           'form-control': true,
                                                           'input-with-dollar': true,
                                                           'po-vendor-input': true}"
                  type="text" [(ngModel)]="item.fee_ship"
                  [placeholder]="isSplitedItem && (!item.fee_ship || item.fee_ship === 0) ? 'Shipping reset after split - add cost' : 'Type here'"
                  [disabled]="item.is_free_shipping"
                  id="fee_ship{{ j }}" name="fee_ship{{ j }}" required #fee_ship="ngModel"
                  currencyMask autocomplete="off" [options]="currencyMaskOptions"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="shippingChargesChangeFn(item)">
                <!-- Visual indicator for missing shipping on split PO ONLY -->
                @if (isSplitedItem && !item.is_free_shipping && (!item.fee_ship || item.fee_ship === 0)) {
                  <div
                    class="position-absolute"
                    style="top: -8px; right: -8px; z-index: 10;">
                    <span class="badge badge-warning text-dark"
                      style="font-size: 10px; padding: 2px 4px; border-radius: 50%;"
                      matTooltip="Shipping cost was reset after split - please add shipping charges">
                      !
                    </span>
                  </div>
                }
              </div>
              <!-- Stage 6.7: Vendor Tax Input -->
              <div class="col-auto">
                <label for="vendor_tax" class="col-form-label text-black po-vendor-label" matTooltip="Tax charged by vendor" matTooltipPosition="above">Tax</label>
              </div>
              <div class="col position-relative">
                <span class="dollar-sign">$</span>
                <input
                  type="text"
                  class="form-control input-with-dollar po-vendor-input"
                  currencyMask
                  autocomplete="off"
                  [options]="currencyMaskOptions"
                  [(ngModel)]="item.vendor_tax"
                  placeholder="0.00"
                  id="vendor_tax{{ j }}"
                  name="vendor_tax{{ j }}"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="vendorTaxChangeFn(item)" />
              </div>
              <!-- Amount + Close grouped right -->
              <div class="po-vendor-row__amount-group">
                <label for="amount" class="col-form-label text-black po-vendor-label">Amount</label>
                @if (!purchaseOrderObject.price_engineering_flag && !item?.is_discount) {
                  <div class="po-vendor-amount-display">{{ item.quote_amount | currency:'USD' }}</div>
                } @else {
                  <div class="position-relative">
                    <span class="dollar-sign">$</span>
                    <input
                      [ngClass]="{'border-red': (quote_amount.touched || purchaseForm.submitted) && quote_amount.errors?.['required']}"
                      type="text" class="form-control input-with-dollar po-vendor-input" currencyMask
                      autocomplete="off" [options]="currencyMaskOptions"
                      [(ngModel)]="item.quote_amount" placeholder="Type here"
                      id="quote_amount{{ j }}" name="quote_amount{{ j }}" required
                      #quote_amount="ngModel" [ngModelOptions]="{standalone: true}"
                      (blur)="quoteAmountchangeFn(item)" />
                  </div>
                }
                <div class="quotes-tab-close" (click)="removeVendorFn(item,j)">
                  <mat-icon>close</mat-icon>
                </div>
              </div>
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div style="overflow: auto;">
          <div class="table-responsive">
            <table class="table table-bordered table-purchase-order" style="width:100%">
              <thead>
                <tr>
                  @if (purchaseOrderObject.group_material_flag && item.materialList.length > 1) {
                    <th scope="col"
                      [ngStyle]="{'padding': purchaseOrderObject.group_material_flag ? '10px 15px':'10px 10px 0px 0px'}">
                      <mat-checkbox class="example-margin bidone-checkbox"
                        [disabled]="true"
                        class="pr-3" [(ngModel)]="allSplitMaterialSelected"
                        (ngModelChange)="allSplitMaterialSelectionFn($event)"
                      [ngModelOptions]="{standalone:true}"></mat-checkbox>
                    </th>
                  }
                  <th scope="col">JOB NO </th>
                  <th scope="col">Material</th>
                  <th scope="col">SCOPES</th>
                  <th scope="col"> QTY IN HAND</th>
                  <th scope="col">ORDER QTY</th>
                  <th scope="col">UNIT COST</th>
                  <th scope="col">CONTRACT COST</th>
                  <th scope="col">EST. VENDOR TAX</th>
                </tr>
              </thead>
              <tbody>
                @for (t of item.materialList; track t; let i = $index) {
                  <tr class="table-content">
                    @if (purchaseOrderObject.group_material_flag && item.materialList.length > 1) {
                      <td>
                        <mat-checkbox
                          [ngModel]="isSplitedItem ? t.isSplitMaterial : t.isGroupMaterial"
                          class="example-margin bidone-checkbox"
                          (ngModelChange)="isSplitedItem ? setSplitItemSelect($event,item,t) : selectedSplitMaterialFn($event,item,t)"
                          [name]="(isSplitedItem ? 'isSplitMaterial' : 'isGroupMaterial') + item.vendorCode + '_' + item.uniqueCode + '_' + j + '_' + i"
                          [id]="(isSplitedItem ? 'isSplitMaterial' : 'isGroupMaterial') + item.vendorCode + '_' + item.uniqueCode + '_' + j + '_' + i"
                          [ngModelOptions]="{standalone: true}">
                        </mat-checkbox>
                      </td>
                    }
                    <td class="pt-4">{{t?.job_number}} </td>
                    <td class="pt-4">{{t.product_name}} </td>
                    <td class="pt-4">{{t?.scope_name}}</td>
                    <td class="pt-4">{{t?.quantity_on_hand||'-'}}</td>
                    <td class="pt-4">
                      {{ purchaseOrderObject.price_engineering_flag ? t?.new_quantity : t?.quantity }}
                    </td>
                    <td class="pt-4">
                      {{ t?.unit_price | currency :'USD' }}
                    </td>
                    <td class="pt-4">
                      @if (purchaseOrderObject.price_engineering_flag) {
                        {{t.new_quantity_total | currency :'USD' }}
                      } @else {
                        {{ t?.previous_quantity_total | currency :'USD' }}
                      }
                    </td>
                    <!-- Stage 6.7: Estimated Vendor Tax Column -->
                    <td class="pt-4">
                      {{ (t?.estimated_vendor_tax || 0) | currency :'USD' }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  }
} @else {
  <div class="d-flex justify-content-center align-items-center text-black-50 placeholder-position">
    <div class="d-flex align-items-center flex-column">
      <div>
        Please select a scope first
      </div>
      <div>
        then choose an item from the List.
      </div>
    </div>
  </div>
}


